export const courseDuration = course => {
  if (course.is_lms_hosted) {
    const hours = course.lms_course_details?.estimatedHours;
    return typeof hours === 'number' && hours > 0
      ? `${hours} estimated ${hours === 1 ? 'hour' : 'hours'}`
      : 'Duration to be confirmed';
  }
  return course.duration_months ? `${course.duration_months} ${Number(course.duration_months) === 1 ? 'month' : 'months'}` : 'Duration to be confirmed';
};
